import React, { useState, useEffect } from "react";
import { Box, Grid, Typography } from "@mui/material";
import { Carousel } from "react-responsive-carousel";
import ApiService from "./../../services/api-service";
import Loader from "./../../components/Loader";
import VideoBanner from "./VideoBanner";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import "./index.scss";

export default function TopBan() {
  const [banner, setBanner] = useState([]);
  const [loading, setLoading] = useState(false);

  const getBanner = async () => {
    try {
      setLoading(true);
      const response = await ApiService.BANNER();
      setBanner([...response.result.data]);
      console.log("Banner Data:", response.result.data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    getBanner();
  }, []);

  return (
    <Box
      sx={{
        width: "100%",
        padding: "40px 0",
        backgroundColor: "#0d0d0d",
        display: "flex",
        borderRadius: "20px",

        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          maxWidth: "1200px",
          width: "100%",
          backgroundColor: "rgba(255, 255, 255, 0.05)",
          padding: "30px",
          borderRadius: "20px",
          boxShadow: "0px 8px 24px rgba(0, 0, 0, 0.8)",
          display: "flex",
          justifyContent: "space-between",
          gap: "30px",
        }}
      >
        {/* Left Side: Carousel Banner */}
        <Box
          sx={{
            width: "100%",
            height: "100%",
            borderRadius: "16px",
            overflow: "hidden",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.5)",
            background: "linear-gradient(135deg, rgba(255,255,255,0.08), rgba(0,0,0,0.08))",
            borderRadius: "4px",
            position: "relative",
            flex: 1,
          }}
        >
          <Typography
            variant="h5"
            sx={{
              position: "absolute",
              top: "15px",
              left: "15px",
              color: "#FFF",
              background: "rgba(0, 0, 0, 0.5)",
              padding: "4px 8px",
              borderRadius: "4px",
              fontWeight: 600,
            }}
          >
            Featured Content
          </Typography>
          {loading ? (
            <Loader />
          ) : banner.length > 0 ? (
            <Carousel
              showThumbs={false}
              autoPlay
              interval={6000}
              transitionTime={600}
              infiniteLoop
              showArrows
              showStatus={false}
              onChange={() => {}}
              renderArrowPrev={(onClickHandler, hasPrev) =>
                hasPrev && (
                  <Box
                    sx={{
                      position: "absolute",
                      left: "10px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      zIndex: 1,
                      color: "white",
                      cursor: "pointer",
                      fontSize: "24px",
                    }}
                    onClick={onClickHandler}
                  >
                    ◀
                  </Box>
                )
              }
              renderArrowNext={(onClickHandler, hasNext) =>
                hasNext && (
                  <Box
                    sx={{
                      position: "absolute",
                      right: "10px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      zIndex: 1,
                      color: "white",
                      cursor: "pointer",
                      fontSize: "24px",
                    }}
                    onClick={onClickHandler}
                  >
                    ▶
                  </Box>
                )
              }
            >

          {banner.map((b, index) => (
            <Box
              key={index}
              sx={{
                overflow: "hidden",
                borderRadius: "16px",
                "& img": {
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  transition: "transform 0.3s ease",
                },
                "&:hover img": {
                  transform: "scale(1.05)",
                },
              }}
            >
              <a
                href={b.url || "#"}
                target="_blank"
                rel="noopener noreferrer"
                style={{ display: "block", width: "100%", height: "100%" }}
              >
                <img src={b.image ? b.image.filePath : ""} alt="Banner" />
              </a>
            </Box>
              ))}
            </Carousel>
          ) : (
            <Box
              sx={{
                backgroundColor: "#1a1a1a",
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "white",
              }}
            >
              <Typography variant="h6" sx={{ opacity: 0.7 }}>
                Banner Placeholder
              </Typography>
            </Box>
          )}
        </Box>

        {/* Right Side: Video Banner */}
        <Box
          sx={{
            width: "100%",
            height: "100%",
            borderRadius: "16px",
            overflow: "hidden",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "linear-gradient(135deg, rgba(255,255,255,0.08), rgba(0,0,0,0.08))",
            flex: 1,
            "&:hover": {
              transform: "scale(1.02)",
              transition: "transform 0.3s ease-in-out",
            },
          }}
        >
          <VideoBanner />
        </Box>
      </Box>
    </Box>
  );
}
